import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { cn } from "@/lib/utils";
import type { CycleRunProgressDto, GenerateDraftRun } from "@/lib/api";
import type { ActiveGenerateDraftRun } from "./generateDraftRun";

interface GenerateDraftBannerProps {
  activeRun: ActiveGenerateDraftRun;
  run: GenerateDraftRun | null;
  isGenerating: boolean;
  progress: CycleRunProgressDto | null;
  onDismiss: () => void;
}

export function GenerateDraftBanner({
  activeRun,
  run,
  isGenerating,
  progress,
  onDismiss,
}: GenerateDraftBannerProps) {
  return (
    <Card
      className={cn(
        "border",
        isGenerating
          ? "border-primary/30 bg-primary/5"
          : run?.status === "Failed"
            ? "border-destructive/30 bg-destructive/5"
            : "border-green-200 bg-green-50",
      )}
    >
      <CardContent className="py-4">
        {isGenerating ? (
          <div className="space-y-2">
            <div className="flex items-center gap-2 text-sm font-medium">
              <Loader2 className="h-4 w-4 animate-spin" />
              Gerando rascunho: {activeRun.sourceYear} → {activeRun.targetYear}
            </div>
            <Progress value={progress?.percentComplete ?? 0} className="h-2" />
            <p className="text-xs text-muted-foreground">
              {progress
                ? `${progress.processed} de ${progress.totalExpected} itens (${Math.round(progress.percentComplete)}%)`
                : "Iniciando..."}
            </p>
          </div>
        ) : run?.status === "Completed" ? (
          <div className="flex items-center justify-between gap-3 text-sm">
            <span className="flex items-center gap-2 text-green-800">
              <CheckCircle2 className="h-4 w-4" />
              Rascunho {activeRun.sourceYear} → {activeRun.targetYear} concluído:{" "}
              {run.generatedCount} criado(s), {run.skippedCount} ignorado(s).
            </span>
            <Button size="sm" variant="ghost" onClick={onDismiss}>
              Dispensar
            </Button>
          </div>
        ) : run?.status === "Failed" ? (
          <div className="flex items-center justify-between gap-3 text-sm">
            <span className="flex items-center gap-2 text-destructive">
              <XCircle className="h-4 w-4" />
              Falha ao gerar {activeRun.sourceYear} → {activeRun.targetYear}:{" "}
              {run.errorMessage || "erro desconhecido"}.
            </span>
            <Button size="sm" variant="ghost" onClick={onDismiss}>
              Dispensar
            </Button>
          </div>
        ) : null}
      </CardContent>
    </Card>
  );
}
